<template>
  <div class="credit-card-card" :class="{ 'connected': isConnected }">
    <div class="top-container">
      <div class="logo-container">
        <img class="logo-image" :src="require(`@/assets/bank-logos/${source.logoFileStacked}`)">
        <div class="is-connected-logo-wrapper" :class="{ 'connected': isConnected }">
          <template v-if="isConnected">
            <div>מחובר</div>
            <img class="is-connected-logo" :src="require('@/assets/onboarding/icons/icon-small-check.svg')">
          </template>
          <template v-else>
            <div>לא מחובר</div>
            <img class="not-connected-logo" :src="require('@/assets/onboarding/icons/icon-small-lock.svg')">
          </template>
        </div>
      </div>
      <div class="billing-amount">{{ formattedAmount }}</div>
      <div class="card-details">{{ cardDetails }}</div>
    </div>
    <div v-if="!isConnected">
      <separator/>
      <div class="button-container">
        <riseup-button class="connect-credit-card-button" :action="connectCreditCard" :title="'לחיבור חשבון האשראי'" :size="'small'"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import BaseUI from 'base-ui';
import moneyUtils from '../../utils/money';

export default {
  name: 'CreditCardCard',
  props: {
    source: {
      type: Object,
      required: true,
    },
    isConnected: {
      type: Boolean,
      default: false,
    },
    businessName: {
      type: String,
    },
    billingAmount: {
      type: Number,
      required: true,
    },
    billingDate: {
      type: String,
      required: true,
    },
    connectCreditCard: {
      type: Function,
      required: true,
    },
  },
  components: {
    Separator: BaseUI.Separator,
    RiseupButton: BaseUI.RiseupButton,
  },
  computed: {
    cardDetails() {
      return `${this.businessName} (חיוב אחרון  ${moment(this.billingDate).format('DD.MM')})`;
    },
    formattedAmount() {
      return `${moneyUtils.formatAmountWithFraction(this.billingAmount, 2)} ₪`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .credit-card-card {
    border: solid 1px $riseup_v2_grey;
    border-radius: 10px;
    box-shadow: 0 5px 10px 0 rgba(194, 196, 210, 0.5);
    width: 100%;
    background-color: $riseup-white;

    &.connected {
      height: 193px;
    }

    .top-container {
      @include responsive-padding;
      @include responsive-padding-top-bottom;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;

      .logo-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 50px;

        .logo-image {
          height: 30px;
          width: 130px;
        }

        .is-connected-logo-wrapper{
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 29px;
          padding: 0 10px;
          border: solid 1px $riseup_v2_grey;
          border-radius: 4px;
          background-color: $riseup_v2_light_grey;
          color: #a19d9d;
          font-size: 14px;
          font-weight: bold;

          &.connected {
            background-color: $riseup_v2_green;
            border: solid 1px $riseup_v2_light_green;
            color: $riseup_white;
          }

          .is-connected-logo {
            height: 11px;
            margin-right: 10px;
          }

          .not-connected-logo {
            height: 15px;
            margin-right: 10px;
          }
        }
      }

      .billing-amount {
        font-size: 28px;
        font-weight: bold;
        font-family: SimplerPro;
        color: $riseup_black;
        margin-bottom: 20px;
      }

      .card-details {
        font-size: 14px;
        font-family: SimplerPro;
        color: $riseup_black;
      }
    }

    .button-container {
      @include responsive-padding-top-bottom;
      @include responsive-padding;

        .connect-credit-card-button {
          width: 100%;
      }
    }
  }
</style>
